import React from 'react';
import {Link} from 'react-router-dom';
import '../assets/styles/components/StageMenu.sass';

const VideosMenu = () => (
  <div className="row stage-menu">
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <ul className="stage-menu__list">
            <li className="stage-menu__list--item">
              <Link id="videosPrologo" to="/home-carrera/videos-prologue">
                PROLOGUE
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa1" to="/home-carrera/videos-stage-one">
                STAGE 1
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa2" to="/home-carrera/videos-stage-two">
                STAGE 2
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa3" to="/home-carrera/videos-stage-three">
                STAGE 3
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa4" to="/home-carrera/videos-stage-four">
                STAGE 4
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa5" to="/home-carrera/videos-stage-five">
                STAGE 5
              </Link>
            </li>
            <li className="stage-menu__list--item">
              <Link id="videosEtapa6" to="/home-carrera/videos-stage-six">
                STAGE 6
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default VideosMenu;